module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_03-02dd6c8ca3b1b778dd72ddb7417e6c2a.png";